export default __webpack_public_path__ + "static/media/june.3d089f07.jpg";